import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { COLOR } from '@src/styles/color';
import { SURVEY_DISPLAY_TYPE } from '@src/constants/survey';
import { getLocalizedTitle } from '@src/services/educatorsSurvey';
import QuestionSelect from './QuestionSelect';
import QuestionTags from './QuestionTags';
import OtherTextArea from './OtherTextArea';

const Question = ({
  question,
  answer,
  otherText,
  placeholder,
  onSelect,
  onChangeOtherText,
}) => {
  const { i18n } = useTranslation();
  const { language } = i18n;

  const selectedOptions = answer?.selectedOptions || [];
  const hasCustomSelected = selectedOptions.some((option) => option.isCustom);

  return (
    <div className="survey-question">
      <Typography
        variant="body-14-medium"
        color={COLOR.darkGray}
        className="survey-question-label"
      >
        {getLocalizedTitle(question.title, language)}
      </Typography>

      {question.displayType === SURVEY_DISPLAY_TYPE.DROPDOWN && (
        <QuestionSelect
          question={question}
          placeholder={placeholder}
          selectedOption={selectedOptions[0]}
          onSelect={onSelect}
        />
      )}

      {question.displayType === SURVEY_DISPLAY_TYPE.CARD && (
        <QuestionTags
          question={question}
          selectedOptions={selectedOptions}
          onSelect={onSelect}
        />
      )}

      {hasCustomSelected && (
        <OtherTextArea value={otherText} onChange={onChangeOtherText} />
      )}
    </div>
  );
};

export default Question;
